'use client'

import React, { useEffect, ReactNode, useRef } from 'react'
import { useAITerminal } from './AITerminal'
import { tradingTools } from './tools/tradingTools'

interface TradingPageWrapperProps {
  children: ReactNode
  symbol: string
  context?: any
}

const TradingPageWrapper: React.FC<TradingPageWrapperProps> = ({
  children,
  symbol,
  context = {}
}) => {
  const { registerTool, updatePageContext } = useAITerminal()
  
  // Track previous values to prevent unnecessary updates
  const prevSymbolRef = useRef<string | undefined>(undefined)
  const prevContextRef = useRef<string | undefined>(undefined)

  // Register all trading tools on mount
  useEffect(() => {
    console.log('🔧 TradingPageWrapper: Registering tools:', tradingTools.map(t => t.name))
    tradingTools.forEach(tool => {
      console.log(`📝 Registering tool: ${tool.name}`)
      registerTool(tool)
    })
  }, []) // Empty dependency array to run only once

  // Update context only when symbol or context actually changes
  useEffect(() => {
    const contextString = JSON.stringify(context)
    
    // Only update if symbol or context actually changed
    if (prevSymbolRef.current !== symbol || prevContextRef.current !== contextString) {
      console.log('📋 TradingPageWrapper: Updating page context for symbol:', symbol)
      
      updatePageContext({
        currentSymbol: symbol,
        currentTimeframe: '1h', // Default timeframe
        activeTab: 'chart',
        ...context,
        lastUpdated: Date.now() // Add timestamp for tracking
      })
      
      // Update refs
      prevSymbolRef.current = symbol
      prevContextRef.current = contextString
    }
  }, [symbol, context, updatePageContext])

  return <>{children}</>
}

export default TradingPageWrapper 